import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { defaultTemplate } from 'core/hoc';
import { BasicInput, BaasicButton, BaasicModal, GlobalSignalRListener } from 'core/components';
import { Content } from 'core/layouts';
import { Editor, EditorTools } from "@progress/kendo-react-editor";
import { dropletIcon } from "@progress/kendo-svg-icons";

function NikoInsuranceCoverageStatusOverviewEmailEditTemplate({ insuranceCoverageStatusOverviewEmailEditViewStore, t }) {
    const {
        contentLoading,
        form,
        sendEmail,
        closePage,
        body,
        isLoading,
        download,
        fetchingData,
        isEmailSent,
        sendManuallyConfirmationModal,
        opetSendEmailManuallyModal,
        emailSentInfo,
        facilityOrderId,
        rootStore,
        signalRAction,
        isManuallyLoading
    } = insuranceCoverageStatusOverviewEmailEditViewStore;

    const {
        Bold,
        Italic,
        Underline,
        AlignLeft,
        AlignCenter,
        AlignRight,
        AlignJustify,
        DeleteRow,
        Undo,
        Redo,
        AddRowBefore,
        AddRowAfter,
        DeleteTable
    } = EditorTools;

    const styles = `
    body {
        font-family: Arial, Helvetica, sans-serif; 
        color: #0D131B;
        background-color: #F8F9FB;
        color: #0D131B;
    }
    table, tr, td {
        border-collapse: collapse;
    }
    tr {
        font-size: 0px;
        line-height: 0px;
        border-collapse: collapse;
    }
    h1 {
        font-size: 20px;
        line-height: 24px;
        margin-top: 0;
        margin-bottom: 0;
        font-weight: 500;
    }
    h2 {
        font-size: 16px;
        line-height: 18px;
        font-weight: 500;
        margin: 0;
    }
    .align-right {
        margin-left: auto;
    }
    .width-100 {
        width: 100%;
    }
    .no-wrap {
        white-space: nowrap;
    }
    .ProseMirror .no-wrap.margin-sml {
        margin-bottom: 0 !important;
    }
    .tbl-facility-name {
        display: inline-block;
        color: #6D747A;
        margin-right: 3px;
        font-size: 14px !important;
    }
    .tbl-facility-name-item {
        display: inline-block;
        color: #003171;
        font-size: 14px !important;
    }
    .tbl-delivery-date {
        display: inline-block;
        color: #6D747A;
        margin-right: 3px;
        font-size: 14px !important;
    }
    .tbl-delivery-date-item {
        display: inline-block;
        color: #003171;
        font-size: 14px !important;
    }
    p {
        margin: 0px !important;
        line-height: normal;
    }
    hr {
        height: 1px;
        border: 0;
        background-color: #D2DBE5;
        margin-top: 8px;
        margin-bottom: 8px;
    }
    table {
        width: 100%;
        border-spacing: 0 2px;
        border-collapse: collapse;
    }
    .tbl-top {
        border-radius: 6px 6px 0 0;
    }
    .tbl-top th {
        border-radius: 6px 6px 0 0;
    }
    .ProseMirror td.tbl-header-top {
        background-color: #003171;
        padding: 16px 24px;
    }
    .ProseMirror .tbl-header {
        table-layout: auto;
    }
    .ProseMirror .tbl-wrapper {
        border-radius: 8px;
        border-color: #DEE3E8;
        border-collapse: separate;
    }
    .ProseMirror .tbl-wrapper > tr, .tbl-wrapper > tbody > tr {
        border-radius: 8px;
    }
    .ProseMirror .tbl-wrapper > tr > td {
        padding: 24px;
        background-color: white;
        border-color: #DEE3E8;
        border-radius: 8px;
    }
    .tbl-header > thead > tr > th,
    .tbl-header > tr > th {
        text-align: left;
        box-sizing: border-box;
        vertical-align: middle;
        border: 0;
        padding: 0;
    }
    .tbl-header > tbody > tr > th {
        text-align: left;
        box-sizing: border-box;
        vertical-align: middle;
        border: 0;
        padding: 0;
    }
    .tbl-header > tbody > tr > td,
    .tbl-header > tr > td {
        text-align: left;
        box-sizing: border-box;
        vertical-align: middle;
        border: 0;
        padding: 0;
        white-space: nowrap;
    }
    .tbl-header > thead > tr > th,
    .tbl-header > tr > th {
        text-align: left;
        box-sizing: border-box;
        vertical-align: middle;
        padding-bottom: 2px;
        font-size: 12px !important;
        height: 12px;
        text-transform: uppercase;
        letter-spacing: 0.8px;
    }
    .tbl-header > tbody > tr > th {
        text-align: left;
        box-sizing: border-box;
        vertical-align: middle;
        padding-bottom: 2px;
        font-size: 12px !important;
        height: 12px;
        text-transform: uppercase;
        letter-spacing: 0.8px;
    }
    .tbl-header > tbody > tr > td,
    .tbl-header > tr > td {
        text-align: left;
        box-sizing: border-box;
        vertical-align: middle;
        font-size: 14px;
        height: 16px;
    }
    .ProseMirror table .tbl-blue {
        border-collapse: collapse;
        background-color: #DEE3E8;
        border-radius: 6px;
    }
    .tbl-blue > tr > th {
        box-sizing: border-box;
        text-align: left;
        vertical-align: middle;
        padding: 6px 9px;
        font-size: 12px !important;
        height: 28px;
        border: 0;
        border: none;
        background-color: #F8F9FB;
        color: #6B6F75;
        border: 1px solid #DEE3E8;
    }

    .tbl-blue > tr > th p {
        font-size: 12px !important;
    }
    .tbl-blue > tr > th:first-child {
        border-radius: 6px 0 0 0;
    }
    .tbl-blue > tr > th:last-child {
        border-radius: 0 6px 0 0;
    }
    .tbl-blue > tr > th {
        box-sizing: border-box;
        text-align: left;
        vertical-align: middle;
        padding: 6px 9px;
        font-size: 12px;
        height: 28px;
        border: 0;
        border: none;
        background-color: #F8F9FB;
        color: #6B6F75;
        font-weight: 500;
        border: 1px solid #DEE3E8;
    }
    .tbl-blue > tr:last-child > th:first-child {
        border-radius: 0 0 0 6px;
    }
    .tbl-blue > tr:last-child > th:last-child {
        border-radius: 0 0 6px 0;
    }
    .tbl-blue > thead > tr > th > p {
        box-sizing: border-box;
        text-align: left;
        vertical-align: middle;
        text-transform: uppercase;
        color: #6B6F75;
        font-weight: 500;
    }
    .tbl-blue > tr > th > p {
        box-sizing: border-box;
        text-align: left;vertical-align: middle;
        text-transform: uppercase;
        color: #6B6F75;
    }
    .tbl-blue > tr > td {
        box-sizing: border-box;
        vertical-align: middle;
        padding: 6px 9px;
        font-size: 14px;
        height: 34px;
        color: #081420;
        border: 0;
        border: none;
        background-color: white;
        border: 1px solid #DEE3E8;
    }

    .tbl-blue > tr > td p span[style*="background-color"] {
        display: inline-block !important;
    }

    .tbl-blue > tr:nth-child(odd) > td {
        background-color: #F8F9FB;
    }
    .tbl-blue > tr:last-child > td:first-child {
        border-radius: 0 0 0 6px;
    }
    .tbl-blue > tr:last-child > td:last-child {
        border-radius: 0 0 6px 0;
    }
    .tbl-header-wrapper td {
        border: 0px;
    }
    .ProseMirror .tbl-wrapper-title {
        margin: 0;
        border-collapse: collapse;
        table-layout: auto;
        width: auto;
        overflow: hidden;
        border: 0;
    }
    .ProseMirror .tbl-wrapper-title td {
        vertical-align: middle;
        border: 0;
        font-size: 10px;
        padding: 0;
    }
    .ProseMirror .tbl-wrapper-title td p {
        display: inline-block;
    }
    .ProseMirror .tbl-wrapper-title td br {
        display: inline-block;
    }
    .ProseMirror .tbl-wrapper-title td img {
        vertical-align: middle;
    }
    .ProseMirror .tbl-label-not td:first-child img {
        margin-right: 0px;
    }
    .ProseMirror .tbl-wrapper-note {
        background-color: #FFF7EF;
        table-layout: auto;
        border-radius: 6px;
    }
    .tbl-wrapper-title {
        width: auto;
    }
    .tbl-wrapper-title td {
        vertical-align: center;
        padding: 0;
    }
    .ProseMirror .tbl-wrapper-note td {
        padding: 12px 3px;
        border: none;
        border-radius: 6px;
        font-size: 12px;
        vertical-align: middle;
    }
    .ProseMirror .tbl-wrapper-note td .ProseMirror-separator {
        display: none;
    }
    .ProseMirror .tbl-wrapper-note td:first-child {
        padding-left: 12px;
    }
    .ProseMirror .tbl-wrapper-note td:last-child {
        padding-right: 12px;
    }
    .ProseMirror .tbl-label-not {
        font-size: 10px;
        text-transform: uppercase;
        color: #D13737;
    }
    .ProseMirror .tbl-label-not p {
        font-size: 10px;
        text-transform: uppercase;
        color: #D13737;
    }
    .ProseMirror .tbl-label-not .ProseMirror-separator {
        display: none;
    }
    .ProseMirror .tbl-label-not table {
        width: auto;
        background-color: #FBEFEF;
        margin-left: 6px;
    }
    .ProseMirror .tbl-label-not table td {
        padding: 3px;
        color: #D13737;
        vertical-align: middle;
    }
    .ProseMirror .tbl-label-not table td:first-child {
        padding-left: 6px;
    }
    .ProseMirror .tbl-label-not table td:last-child {
        padding-right: 6px;
    }
    .ProseMirror .tbl-label-not table,
    .ProseMirror .tbl-label-not table td {
        border-radius: 6px 6px 0 0;
    }

    .tbl-table-not-top {
        padding: 0 !important;
    }

    .tbl-table-not-top > table {
        margin-left: 0 !important;
    }

    .tbl-table-not-single > table {
        margin-left: 0 !important;
        border-radius: 6px !important;
    }

    .tbl-table-not-single > table td { 
        margin-left: 0 !important;
        border-radius: 6px !important;
    }

    .ProseMirror .tbl-title-line {
        width: auto;
        border: 0px;
    }
    .ProseMirror .tbl-title-line td {
        border: 0px;
        vertical-align: middle;
    }
    .ProseMirror .tbl-spacer td {
        border: 0px;
    }
    .p-hospice {
        text-align: left;
        margin-left: 0px !important;
        padding-left: 0px !important;
        font-size: 12px;
        line-height: 16px;
        color: #6B6F75;
    }
    .tbl-subtitle {
        font-size: 12px;
    }
    .innovative-logo {
        display: block;
        height: 30px;
        margin-bottom: 7px;
        margin-left: auto;
        outline: 0 !important;
    }
    .ProseMirror table.wrapper > tr > td {
        padding: 24px;
        border: 0px;
    }
    .ProseMirror table.table-right {
        margin: 0;
        border-collapse: collapse;
        table-layout: fixed;
        width: auto;
        overflow: visible;
    }
    .table-right tr {
        font-size: 14px;
        height: auto;
    }
    .mso-spacer { display: none !important}

    .ProseMirror-hideselection *::selection {
        background-color: transparent;
        color: black !important;
    }

    /* v14's ProseMirror editor leaves selection to Chrome's default
       (semi-transparent blue, blends with the back-color spans). v3's editor
       used the opaque system highlight; match it so selecting coloured text
       shows a solid highlight instead of a mixed/blended one. */
    ::selection {
        background-color: highlight;
        color: highlighttext;
    }

    /* v14's prosemirror-tables draws its own translucent cell-selection overlay
       (.selectedCell::after) and forces the native selection background transparent
       so the two don't stack. The ::selection colour above (highlighttext = white)
       then leaves selected cell text white-on-transparent = invisible. Keep each
       element's own text colour in that state so cell content stays readable under
       the overlay (mirrors the .ProseMirror-hideselection transparent-bg case). */
    .ProseMirror .selectedCell ::selection {
        color: currentColor;
    }
    `;

    const onMount = (event) => {
        const iframeDocument = event.dom.ownerDocument;
        const style = iframeDocument.createElement("style");
        style.appendChild(iframeDocument.createTextNode(styles));
        iframeDocument.head.appendChild(style);
    };

    const resize = {
        resize: 'vertical',
        overflow: "auto"
    };

    const wordPalette = [
        '#ffffff00', '#00ff00', '#00ffff','#ff00ff', 
        '#0000ff','#FF0000', '#ffff00','#000000'
    ];

    const CustomBackColor = (props) => (
        <EditorTools.BackColor
            {...props}
            colorPickerProps={{
                // v14: render the droplet fill glyph. v3-5's icon/iconClassName font-icon props
                // no longer resolve, leaving v14's live color-preview to show a red "no color" slash.
                svgIcon: dropletIcon,
                view: "palette",
                paletteSettings: {
                    palette: wordPalette,
                    columns: 4,
                    rows: 2,
                    tileSize: 30,
                },
            }}
        />
    );

    return (
        <React.Fragment>
            <GlobalSignalRListener groupId={facilityOrderId} rootStore={rootStore} action={signalRAction} />
            <div className="container">
                <form onSubmit={form.onSubmit}>
                    <div className="content__main has-padding">
                        <Content loading={contentLoading || fetchingData} >
                            <div className="row">
                                <div className="col col-sml-12 col-lrg-11">
                                    <div className="card card--form card--primary card--med">
                                        <div className="form__group">
                                            <BasicInput
                                                field={form.$("to")}
                                            />
                                        </div>
                                        <div className="form__group">
                                            <BasicInput
                                                field={form.$("cc")}
                                            />
                                        </div>
                                        <div className="form__group">
                                            <BasicInput
                                                field={form.$("bcc")}
                                            />
                                        </div>
                                        <div className="form__group">
                                            <BasicInput
                                                field={form.$("replyTo")}
                                            />
                                        </div>
                                        <div className="form__group">
                                            <BasicInput
                                                field={form.$("subject")}
                                            />
                                        </div>
                                        <div className="form__group">
                                            {/* <BasicTextArea
                                            field={form.$("body")}
                                            multiLineEdit={true}
                                            rows="35"
                                        /> */}
                                            {
                                                body ?
                                                    <Editor
                                                        resizable={true}
                                                        style={{ minHeight: 500, ...resize }}
                                                        tools={[
                                                            [Bold, Italic, Underline],
                                                            [AlignLeft, AlignCenter, AlignRight, AlignJustify],
                                                            [AddRowBefore, AddRowAfter],
                                                            [DeleteRow, DeleteTable],
                                                            [CustomBackColor],
                                                            [Undo, Redo],
                                                        ]}
                                                        contentStyle={{
                                                            minHeight: 442
                                                        }}
                                                        defaultContent={body}
                                                        onMount={onMount}
                                                        onChange={(event) => {
                                                            let parser = new DOMParser();
                                                            let doc = parser.parseFromString(event.html, "text/html");
                                                            const highlightedSpans = Array.from(doc.querySelectorAll("span[style*='background-color']"));
                                                            highlightedSpans.forEach(span => {
                                                                span.style.display = "inline-block";
                                                            });
                                                            form.$("body").set(doc.body.innerHTML);
                                                        }}
                                                    />
                                                    : null
                                            }
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </Content>
                    </div>
                    {emailSentInfo && emailSentInfo.trim() !== "" && (
                        <div className="u-mar--top--med">{emailSentInfo}</div>
                    )}
                    <div className='content__footer col col-sml-12 col-lrg-11'>
                        <BaasicButton
                            className='btn btn--base btn--primary'
                            label="Send"
                            onClick={() => sendEmail()}
                            rotate icon={
                                isLoading
                                    ? "u-icon u-icon--xmed u-icon--sync u-rotate--login"
                                    : 'u-display--none'
                            }
                            disabled={isLoading || isManuallyLoading}
                        />
                        <BaasicButton
                            className='btn btn--base btn--primary'
                            label="Sent Manually"
                            onClick={() => opetSendEmailManuallyModal()}
                            rotate icon={
                                isManuallyLoading
                                    ? "u-icon u-icon--xmed u-icon--sync u-rotate--login"
                                    : 'u-display--none'
                            }
                            disabled={isLoading || isEmailSent || isManuallyLoading}
                        />
                        <BaasicButton
                            className='btn btn--base btn--ghost'
                            label={t('EDIT_FORM_LAYOUT.CANCEL')}
                            onClick={() => closePage()}
                        />

                        <BaasicButton className="btn btn--base btn--primary u-mar--left--auto"
                            label={'Download'}
                            icon='u-icon u-icon--sml u-icon--download--white'
                            onClick={() => download()}>
                        </BaasicButton>
                    </div>
                </form>
                <BaasicModal className="modal__content modal--sml" modalParams={sendManuallyConfirmationModal}>
                    <section>
                        <div className="modal__body type--center">
                            <h3 className='modal__header__title u-mar--top--med u-mar--bottom--med'>Email Sent Manually</h3>
                        </div>
                        <KeyDownListener onConfirm={sendManuallyConfirmationModal.onConfirm} />
                        <div className='modal__footer'>
                            <BaasicButton
                                className='btn btn--med btn--light'
                                label={t('EDIT_FORM_LAYOUT.CANCEL')}
                                disabled={isManuallyLoading}
                                onClick={() => sendManuallyConfirmationModal.close()}
                            />
                            <BaasicButton
                                className='btn btn--med btn--primary'
                                label="Confirm"
                                disabled={isManuallyLoading}
                                focused={true}
                                onClick={() => sendManuallyConfirmationModal.onConfirm()}
                                rotate icon={
                                    isManuallyLoading
                                        ? "u-icon u-icon--xmed u-icon--sync u-rotate--login"
                                        : 'u-display--none'
                                }
                            />
                        </div>
                    </section>
                </BaasicModal>
            </div>
        </React.Fragment>
    )
}

NikoInsuranceCoverageStatusOverviewEmailEditTemplate.propTypes = {
    insuranceCoverageStatusOverviewEmailEditViewStore: PropTypes.object,
    t: PropTypes.func
};

const KeyDownListener = ({ onConfirm }) => {
    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.key === "Enter") {
                onConfirm();
            }
        };
        window.addEventListener("keydown", handleKeyDown);
        return () => {
            window.removeEventListener("keydown", handleKeyDown);
        };
    }, []);
    return null;
}
KeyDownListener.propTypes = {
};

export default defaultTemplate(NikoInsuranceCoverageStatusOverviewEmailEditTemplate);
